export default __webpack_public_path__ + "static/media/Google-Play-Logo-PNG.ce32d165.png";